import { jsonMember, jsonObject } from 'typedjson';

@jsonObject
export class AdminSubscriptionBulkPriceChangeRequest {
  @jsonMember(String)
  public readonly price!: string;

  public constructor(
    private readonly data: {
      price: string;
    },
  ) {
    this.price = this.data.price;
  }
}
